/**
 * @generated SignedSource<<0571ebe0944e62230b7351b196b1ba58>>
 * @relayHash 8fcb2473b986ca1014142a43a97708fd
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d442eeaa919d0ecb43aed098fc1e296770b5f4467029d0febe31eba49f2f5297

import { ConcreteRequest } from 'relay-runtime';
export type schemaPageQuery$variables = {
  account: string;
  branch: string;
  fetchSubgraph: boolean;
  graph: string;
  includeApiSchema: boolean;
  subgraphName: string;
};
export type schemaPageQuery$data = {
  readonly branch: {
    readonly federatedSchema: string | null | undefined;
    readonly schema?: string | null | undefined;
    readonly subgraphs: ReadonlyArray<{
      readonly name: string;
      readonly owners: ReadonlyArray<{
        readonly name: string;
      }>;
    }>;
  };
  readonly subgraph?: {
    readonly schema: string;
  } | null | undefined;
};
export type schemaPageQuery = {
  response: schemaPageQuery$data;
  variables: schemaPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "account"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "branch"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchSubgraph"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "graph"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeApiSchema"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "subgraphName"
},
v6 = {
  "kind": "Variable",
  "name": "accountSlug",
  "variableName": "account"
},
v7 = {
  "kind": "Variable",
  "name": "graphSlug",
  "variableName": "graph"
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "branch"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "federatedSchema",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "schema",
    "storageKey": null
  }
],
v11 = {
  "condition": "includeApiSchema",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v10/*: any*/)
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "condition": "fetchSubgraph",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        (v6/*: any*/),
        {
          "kind": "Variable",
          "name": "branch",
          "variableName": "branch"
        },
        (v7/*: any*/),
        {
          "kind": "Variable",
          "name": "subgraphName",
          "variableName": "subgraphName"
        }
      ],
      "concreteType": "Subgraph",
      "kind": "LinkedField",
      "name": "subgraph",
      "plural": false,
      "selections": (v10/*: any*/),
      "storageKey": null
    }
  ]
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "schemaPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v8/*: any*/),
          "concreteType": "Branch",
          "kind": "LinkedField",
          "name": "branch",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v11/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Subgraph",
              "kind": "LinkedField",
              "name": "subgraphs",
              "plural": true,
              "selections": [
                (v12/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Team",
                  "kind": "LinkedField",
                  "name": "owners",
                  "plural": true,
                  "selections": [
                    (v12/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      (v13/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "schemaPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "Branch",
        "kind": "LinkedField",
        "name": "branch",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Subgraph",
            "kind": "LinkedField",
            "name": "subgraphs",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "owners",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      (v13/*: any*/)
    ]
  },
  "params": {
    "cacheID": "8fcb2473b986ca1014142a43a97708fd",
    "id": "d442eeaa919d0ecb43aed098fc1e296770b5f4467029d0febe31eba49f2f5297",
    "metadata": {},
    "name": "schemaPageQuery",
    "operationKind": "query",
    "text": "query schemaPageQuery(\n  $account: String!\n  $graph: String!\n  $branch: String!\n  $includeApiSchema: Boolean!\n  $subgraphName: String!\n  $fetchSubgraph: Boolean!\n) {\n  branch(accountSlug: $account, graphSlug: $graph, name: $branch) {\n    federatedSchema\n    schema @include(if: $includeApiSchema)\n    subgraphs {\n      name\n      owners {\n        name\n        id\n      }\n    }\n    id\n  }\n  subgraph(accountSlug: $account, graphSlug: $graph, branch: $branch, subgraphName: $subgraphName) @include(if: $fetchSubgraph) {\n    schema\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e4b2f6161f1cbd8f80b842a8841ad31";

export default node;
